module.exports = __webpack_public_path__ + "media/xiuniang.206f6e21.mp3";